import React, { useEffect, useState } from 'react';
import { generateOverallReportItemId, generateReport, getReportSignedUrl, getReportWebLink } from '../Shared/utils';
// import { Col, Container, Row } from 'reactstrap';
import ReportViewer from '../Shared/ReportViewer';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { listSurveys } from '../../../../store/actions';
import Select from 'react-select';
import { Badge, Col, Container, Row } from 'reactstrap';

const SurveySelector = ({ refSurveyId, setItemId }) => {
  // console.log(`SurveySelector: surveyId=${surveyId}`)
  const [surveyOption, setSurveyOption] = useState(null);
  const dispatch = useDispatch()
  const { surveysList, isLoading } = useSelector(state => ({
    surveysList: state.surveyCrud.surveys.filter(survey =>
      survey.surveyStatus === "Completed"
      && survey.surveyId !== refSurveyId
    ),
    isLoading: state.surveyCrud.isLoading
  }))
  const onSelectChange = (event, { action }) => {
    if (action === 'select-option') {
      setSurveyOption(event);
      setItemId(generateOverallReportItemId({ surveyId: refSurveyId, previousId: event.value }));
    }
    if (action === 'clear') {
      setSurveyOption(null);
      setItemId(generateOverallReportItemId({ surveyId: refSurveyId }))
    }
    console.log(surveyOption);
  };
  useEffect(() => {
    dispatch(listSurveys({ surveyId: refSurveyId }));
  }, [dispatch]);
  return <Container><Row className='mt-2 mb-2'>
    <Col md="6">
      <div style={{ textAlign: "right" }}>To compare with a previous assessment: </div>
    </Col>
    <Col md="6">
      <Select
        placeholder={"Please select from the list"}
        options={surveysList.map(survey => ({
          value: survey.surveyId,
          label: <>{survey.surveyName} <Badge pill>{survey.semester} {survey.year}</Badge></>
        }))}
        onChange={onSelectChange}
        value={surveyOption}
        isLoading={isLoading}
        isClearable
      />
    </Col>
  </Row></Container>
}


const Report = (props) => {
  const { templateId, id, isWellnessCenter } = props;
  const parentAuthCode = isWellnessCenter ?
    useSelector(state => state.wellnessCenterAuth.participantInfo.parentSurveyAuthCode)
    : null;
  const location = useLocation();
  const history = useHistory();
  const queryParameters = new URLSearchParams(location.search)
  const [itemId, setItemId] = useState(templateId === "overall" ? generateOverallReportItemId({ surveyId: id }) : id) // itemId is either a simple id retrieved from path, or an object set by SurveySelector
  const [signedUrl, setSignedUrl] = useState(null)
  const [waitMsg, setWaitMsg] = useState('')
  const [unauthorized, setUnauthorized] = useState(null);
  const showSurveySelector = templateId === "overall";

  useEffect(() => {
    const _fn = async () => {
      const forceRegenerate = queryParameters.get("f")
      if (signedUrl) setSignedUrl(null)
      let newSignedUrl;
      if (!forceRegenerate) {
        setWaitMsg('Fetching Report...');
        const _r = await getReportSignedUrl({ id: itemId, template: templateId, parentAuthCode })
        setWaitMsg('');
        if (_r.url) newSignedUrl = _r.url;
        if (_r.error && _r.errorCode === 401) {
          console.log(`Unauthorized: ${_r.msg}`)
          setUnauthorized(_r.msg)
          return;
        }
        if (_r.error && isWellnessCenter) {
          setUnauthorized(`Please contact your school and provide the following error code: ${templateId}-${id}`)
          return;
        }
      }
      // generate on demand
      if (!newSignedUrl) {
        setWaitMsg('Generating report...');
        newSignedUrl = await generateReport({ itemId, templateId })
        setWaitMsg('')
      }
      if (newSignedUrl) {
        setSignedUrl(newSignedUrl)
      } else { // no pdf report found and unable to generate... fallback to previous report
        setWaitMsg('Unable to generate report, fallback to legacy report.')
        const fallbackFn = () => history.push(getReportWebLink({ itemId, templateId, v2: false }))
        setTimeout(fallbackFn, 1000)

        // history.push(`/admin/reports/${templateId}?pId=${itemId}`)
      }
    }
    _fn();
  }, [itemId]);
  if (unauthorized)
    return <>
      <p>You are not authorized to access this report.</p>
      <pre>{unauthorized}</pre>
    </>
  else {
    // If isWellnessCenter is true and signedUrl is available, redirect to signedUrl
    useEffect(() => {
      if (isWellnessCenter && signedUrl) {
        window.location.href = signedUrl;
      }
    }, [isWellnessCenter, signedUrl]);

    return (
      <div style={{ height: "100vh", display: "flex", flexDirection: 'column' }}>
        {showSurveySelector ? <SurveySelector refSurveyId={id} setItemId={setItemId} /> : null}
        {/* Only show ReportViewer if not redirecting for wellness center */}
        {!isWellnessCenter && <ReportViewer url={signedUrl} waitMsg={waitMsg} />}
      </div>
    );
  }

}

export default Report